import uuid from 'uuid/v4'
import axios from 'axios'
import moment from 'moment'
import * as types from '../mutation-types'

const BASE_REDIRECTION_URL = "https://sarasch.com/";

// state
export const state = {
	id: null,
	startTime: null,
	newStartTime: null,
	endTime: null,
	lastActivityTime: null,
	parentModule: null,
	parentId: null,
	maxTime: 1800000,
	renewed: null
}

// getters
export const getters = {
	id: state => {
		return state.id
	},

	newStartTime: state => {
		return state.newStartTime
	},

	maxTime: state => {
		return state.maxTime
	}
}

// mutations
export const mutations = {
	[types.SET_SESSION](state, { session }) {
		state.id = session.id
		state.startTime = session.startTime
		state.newStartTime = session.startTime
		state.renewed = false
	},

	[types.RENEW_SESSION](state) {
		state.renewed = true
		state.newStartTime = moment()
	},

	async [types.SAVE_LAST_ACTIVITY](state) {
		try {
			state.lastActivityTime = moment().format('YYYY-MM-DDTHH:mm:ssZ')
			await axios.post('/api/session/upsert', state)
		} catch (e) {
			throw e;
		}
	},

	async [types.END_SESSION](state) {
		try {
			state.endTime = moment().format('YYYY-MM-DDTHH:mm:ssZ')

			await axios.post('/api/session/upsert', state)

			window.location.href = BASE_REDIRECTION_URL;
		} catch (e) {
			throw e;
		}
	},

	[types.SET_PARENT_VALUES](state, { parent }) {
		try {
			state.parentModule = parent.parentModule
			state.parentId = parent.parentId
		} catch (e) { }
	}
}

// actions
export const actions = {

	async generate({ commit, dispatch }) {
		try {
			// UUID Generator: https://github.com/kelektiv/node-uuid
			let sessionId = uuid()
			let startTime = moment().format('YYYY-MM-DDTHH:mm:ssZ')
			const { data } = await axios.get('/api/session/check', { params: { id: this.sessionId } })
			// If there is an existing Form Session
			if (data.code == 'SES-001') {
				dispatch('generate');
			} else {
				let session = {
					id: sessionId,
					startTime: startTime
				}
				commit(types.SET_SESSION, { session: session })
			}
		} catch (e) {
			throw e;
		}
	},

	async saveLastActivity({ commit }) {
		try {
			await commit(types.SAVE_LAST_ACTIVITY)
		} catch (e) {
			throw e;
		}
	},

	async end({ commit }) {
		try {
		await commit(types.END_SESSION)
		} catch (e) {
			throw e;
		}
	},

	setParentValues({ commit }, parent) {
		commit(types.SET_PARENT_VALUES, parent)
	},

	renew({ commit }) {
		commit(types.RENEW_SESSION)
	}
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/session.js